// Get Shopify Collection Products
export const GET_SHOPIFY_COLLECTION_PRODUCTS_REQUEST = 'GET_SHOPIFY_COLLECTION_PRODUCTS_REQUEST';
export const GET_SHOPIFY_COLLECTION_PRODUCTS_DONE = 'GET_SHOPIFY_COLLECTION_PRODUCTS_DONE';
export const GET_SHOPIFY_COLLECTION_PRODUCTS_FAILED = 'GET_SHOPIFY_COLLECTION_PRODUCTS_FAILED';
export const GET_SHOPIFY_COLLECTION_PRODUCTS_RESET = 'GET_SHOPIFY_COLLECTION_PRODUCTS_RESET';
export const SHOPIFY_COLLECTION_PRODUCTS_PROGRESS = 'SHOPIFY_COLLECTION_PRODUCTS_PROGRESS';
